import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import classNames from 'classnames';
import * as Yup from 'yup';
import styled from 'styled-components';

const SectionDescriptionStyled = styled.div`
  width: 570px;
  margin-bottom: 40px;
`;

const TotalStyled = styled.div`
  font-size: 20px;
  font-weight: 500;
  line-height: 1.35;
  color: #0095ff;
`;

class QuoteFormSectionSamples extends React.Component {
  static defaultProps = {
    readOnly: false,
  };

  static propTypes = {
    product: PropTypes.object.isRequired,
    readOnly: PropTypes.bool,
  };

  render() {
    const { product, values, errors, touched, readOnly } = this.props;
    let total =
      (parseFloat(values.samplesTotalPrice) || 0) + (parseFloat(values.samplesShippingCost) || 0);

    return (
      <fieldset>
        <SectionDescriptionStyled>
          Please provide a cost and the expected lead time for the required amount of samples of the
          product. Please do not include delivery in your lead time.
        </SectionDescriptionStyled>

        <div className="row form-group">
          <div className="form-group col-4 col-sm-4">
            <label>Required Quantity</label>
            <div className="form-value vertically-centered">{product.numberSamples}</div>
          </div>
          <div
            className={classNames('form-group col-4 col-sm-4', {
              'with-error': touched.samplesTotalPrice && errors.samplesTotalPrice,
            })}
          >
            <label>Total Price</label>
            <Field
              className="form-control"
              type="number"
              name="samplesTotalPrice"
              placeholder="ex. $4.56"
              disabled={readOnly}
            />
            {touched.samplesTotalPrice &&
              errors.samplesTotalPrice && (
                <label className="error">{errors.samplesTotalPrice}</label>
              )}
          </div>
          <div
            className={classNames('form-group col-4 col-sm-4', {
              'with-error': touched.samplesLeadTime && errors.samplesLeadTime,
            })}
          >
            <label>Lead Time</label>
            <Field
              className="form-control"
              name="samplesLeadTime"
              placeholder="ex. 30 Days"
              disabled={readOnly}
            />
            {touched.samplesLeadTime &&
              errors.samplesLeadTime && <label className="error">{errors.samplesLeadTime}</label>}
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-4">
            <label>Delivery Address for Samples</label>
            <div>{product.deliveryAddress.company}</div>
            <div>{product.deliveryAddress.address}</div>
            <div>{product.deliveryAddress.address2}</div>
            <div>{product.deliveryAddress.country}</div>
          </div>
          <div className="form-group col-sm-4" />
          <div
            className={classNames('form-group col-sm-4', {
              'with-error': touched.samplesShippingCost && errors.samplesShippingCost,
            })}
          >
            <label>Shipping Cost</label>
            <Field
              className="form-control"
              type="number"
              name="samplesShippingCost"
              placeholder="ex. $4.56"
              disabled={readOnly}
            />
            {touched.samplesShippingCost &&
              errors.samplesShippingCost && (
                <label className="error">{errors.samplesShippingCost}</label>
              )}
          </div>
        </div>
        <div className={'section-separator'} />
        <div className="row">
          <div className="form-group col-sm-4">
            <label>Samples and Shipping Total</label>
            <TotalStyled>{total.toFixed(2)}</TotalStyled>
          </div>
        </div>
      </fieldset>
    );
  }
}

export const SamplesValidationScheme = {
  samplesNumber: Yup.number().notRequired(),
  samplesTotalPrice: Yup.mixed().when('samplesNumber', {
    is: (samplesNumber) => samplesNumber > 0,
    then: Yup.number().required('Total Price is required'),
    otherwise: Yup.mixed().notRequired(),
  }),
  samplesLeadTime: Yup.mixed().when('samplesNumber', {
    is: (samplesNumber) => samplesNumber > 0,
    then: Yup.string().required('Lead Time is required'),
    otherwise: Yup.mixed().notRequired(),
  }),
  samplesShippingCost: Yup.mixed().when('samplesNumber', {
    is: (samplesNumber) => samplesNumber > 0,
    then: Yup.number().required('Shipping Cost is required'),
    otherwise: Yup.mixed().notRequired(),
  }),
};

export default QuoteFormSectionSamples;



// WEBPACK FOOTER //
// ./src/component/quote/QuoteFormSectionSamples/index.js